/**
 * @description Centralized query keys for Recepción de Pagos module
 * @author Omar Sánchez Martínez
 * @since 2025-09-23
 */

export const recepcionPagosKeys = {
  // Base key
  all: () => ['recepcionPagos'] as const,

  // Collections
  lists: () => [...recepcionPagosKeys.all(), 'list'] as const,
  list: (facturaId: number) => [...recepcionPagosKeys.lists(), facturaId] as const,

  // PPD Pending Payments
  pendingPayments: () => [...recepcionPagosKeys.all(), 'pendingPayments'] as const,
  pendingPaymentsByEnterprise: (enterpriseId: number) =>
    [...recepcionPagosKeys.pendingPayments(), enterpriseId] as const,

  // Mutations
  mutations: () => [...recepcionPagosKeys.all(), 'mutation'] as const,
  create: (facturaId: number) => [...recepcionPagosKeys.mutations(), 'create', facturaId] as const,
} as const;
